<template>
    <rkm-content>
        <rkm-content-header :title="$route.meta.title">
            <template v-slot:actions>
                <rkm-button
                    :disabled="loading"
                    @click="handleSave"
                    color="success"
                >
                    Salvar
                </rkm-button>
            </template>
        </rkm-content-header>

        <rkm-content-body>
            <rkm-container>
                <rkm-overlay :show="loading">
                    <rkm-form
                        ref="RkmForm"
                        show-legend
                    >
                        <rkm-row>
                            <rkm-col cols="8">
                                <rkm-form-input
                                    disabled
                                    label="Nome"
                                    v-model="model.nome"
                                />
                            </rkm-col>

                            <rkm-col cols="4">
                                <rkm-form-datepicker
                                    disabled
                                    label="Data de nascimento"
                                    v-model="model.data_nascimento"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="2">
                                <rkm-form-input
                                    :validations="validations.telefone_residencial"
                                    label="Telefone residencial"
                                    v-mask="utils.mask.telefone"
                                    v-model="model.telefone_residencial"
                                />
                            </rkm-col>

                            <rkm-col cols="2">
                                <rkm-form-input
                                    :validations="validations.telefone_celular"
                                    label="Telefone celular"
                                    v-mask="utils.mask.celular"
                                    v-model="model.telefone_celular"
                                />
                            </rkm-col>

                            <rkm-col cols="2">
                                <rkm-form-input
                                    :validations="validations.telefone_recado"
                                    label="Telefone de recado"
                                    v-mask="utils.mask.telefone"
                                    v-model="model.telefone_recado"
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <rkm-form-input
                                    :validations="validations.email"
                                    label="E-mail"
                                    v-model="model.email"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="3">
                                <rkm-form-input
                                    disabled
                                    label="Usuário"
                                    v-model="model.login"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-input
                                    class="password"
                                    label="Senha"
                                    v-model="model.senha"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-input
                                    :disabled="!model.senha"
                                    :validations="validations.nova_senha"
                                    class="password"
                                    label="Nova senha"
                                    v-model="model.nova_senha"
                                    vid="nova_senha"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-input
                                    :disabled="!model.nova_senha"
                                    :validations="validations.nova_senha_confirmation"
                                    class="password"
                                    label="Confirmar nova senha"
                                    v-model="model.nova_senha_confirmation"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-form>
                </rkm-overlay>
            </rkm-container>
        </rkm-content-body>
    </rkm-content>
</template>

<script>
// Mixins.
import {error, notification} from '@/mixins'

// Others.
import moment from 'moment'

// Utils.
import format from '@/utils/format'
import mask from '@/utils/mask'
import unmask from '@/utils/unmask'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('perfil-form')
        },
        validations() {
            return {
                telefone_residencial: {
                    required: !this.model.telefone_celular && !this.model.telefone_recado,
                    min: 14,
                    max: 14,
                },
                telefone_celular: {
                    required: !this.model.telefone_residencial && !this.model.telefone_recado,
                    min: 15,
                    max: 15,
                },
                telefone_recado: {
                    required: !this.model.telefone_residencial && !this.model.telefone_celular,
                    min: 14,
                    max: 14,
                },
                email: {
                    required: true,
                    email: true,
                },
                nova_senha: {
                    required: this.model.senha,
                    min: 8,
                    max: 12,
                    senha: true,
                },
                nova_senha_confirmation: {
                    required: this.model.nova_senha,
                    min: 8,
                    max: 12,
                    senha: true,
                    confirmed: 'nova_senha',
                },
            }
        },
    },
    data: () => ({
        form: null,
        model: {
            nome: null,
            data_nascimento: null,
            telefone_residencial: null,
            telefone_celular: null,
            telefone_recado: null,
            email: null,
            login: null,
            senha: null,
            nova_senha: null,
            nova_senha_confirmation: null,
        },
        others: {moment},
        utils: {
            format,
            mask,
            unmask,
        },
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleSave() {
            this.$refs.RkmForm.validate()
                .then(validated => {
                    if (validated === true) {
                        this.setLoading('perfil-form')

                        const request = {
                            telefone_residencial: this.utils.unmask.telefone(this.model.telefone_residencial) || null,
                            telefone_celular: this.utils.unmask.telefone(this.model.telefone_celular) || null,
                            telefone_recado: this.utils.unmask.telefone(this.model.telefone_recado) || null,
                            email: this.model.email,
                            senha: this.model.senha,
                            nova_senha: this.model.nova_senha,
                            nova_senha_confirmation: this.model.nova_senha_confirmation,
                        }

                        this.repositories.perfil.update(request)
                            .then(() => {
                                this.showSuccessNotification()
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading('perfil-form'))
                    }
                })
        },
        load() {
            this.setLoading('perfil-form')

            this.repositories.perfil.edit()
                .then(({data}) => this.model = data.model)
                .catch(this.handleError)
                .finally(() => this.unsetLoading('perfil-form'))
        },
    },
    mixins: [error, notification],
    mounted() {
        this.load()
    },
}
</script>

<style scoped>
.password >>> input {
    -webkit-text-security: disc;
}
</style>